import { isValidSelector } from 'anodum';
import { connectedStore } from '../../store';
import getConstraints from '../selectors/constraints';

const hasConstraints = (element) => {
  const store = connectedStore.get();
  const state = store.getState();
  const constraints = getConstraints(state);

  return constraints.some((constraint) => {
    if (!isValidSelector(constraint.element)) return false;
    return element.matches(constraint.element);
  });
};

export default hasConstraints;
